export function getActiveHitbox() {
    const hitboxSet = new Set();
    Object.entries(servObj).forEach(([key, value]) => {
        if (key.startsWith("active") && !key.includes("activeHitbox") && Array.isArray(value) && value.length > 0) {
            value.forEach((el) => {
                el.traverse((item) => {
                    if (item.name.includes("hitbox") && item.parent.visible) {
                        hitboxSet.add(item);
                    }
                });
            });
        }
        if (key === "redactorModeObject") {
            value.traverse((item) => {
                if (item.name.includes("hitbox") && item.parent.visible) {
                    hitboxSet.add(item);
                }
            });
        }
    });
    const hitboxes = Array.from(hitboxSet);
    servObj.activeHitbox = hitboxes;
}
